





























































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  @Prop() visible!: boolean;
  @Prop() title!: string;

  @Emit()
  close() {}
}
